import { render, staticRenderFns } from "./PoiBanner.vue?vue&type=template&id=6a57e1ea&scoped=true&"
import script from "./PoiBanner.vue?vue&type=script&lang=js&"
export * from "./PoiBanner.vue?vue&type=script&lang=js&"
import style0 from "./PoiBanner.vue?vue&type=style&index=0&id=6a57e1ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a57e1ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSlider})
